import { Card, Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import moment from 'moment/moment';

function SubscriptionDetails() {
    const { subscriptions } = useSelector(state => state.data);

    const findExpire = (endDate) => {
        const currentDate = new Date();
        const expiryDate = new Date(endDate); // Ensure it's a Date object

        const isExpired = currentDate > expiryDate;

        if (isExpired) {
            const diffTime =  currentDate - expiryDate; // Use expiryDate here!
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let class_name = '';
            if(diffDays < 10){
                class_name = 'about_expire'
            } else {
                class_name = 'not_expire'
            }
            return <span className={class_name}>{diffDays} day(s) left</span>;
        } else {
            return <span className='expired-text'>Expired</span>;
        }
    };

  return (
    <Card className='dashboard-subscription-card'>
        <div className='dashboard-subscription-card-header'>
            <h5>Subscription Details </h5>
            {/* <Link to='/allSubscription'>View All</Link> */}
        </div>
        <div className='card-body' style={{overflow: "auto"}}>
            {subscriptions.length !== 0 && 
            <>
            {subscriptions.map((item, index) => {
                return <Row className='dashboard-subscription-inner-card-container pb-2' key={index}>
                    <Col md={12}>
                        <div className='dashboard-subscription-inner-card-details'>
                            <div className='dashboard-subscription-inner-inner-card'>
                                <div className='dashboard-subscription-card-inner-header'>
                                    <h6>{item.email}</h6>
                                    <p>Date&nbsp;:&nbsp;
                                        <span>{moment(item.start_date).format("YYYY-MM-DD")}</span>
                                    </p>
                                    
                                        {findExpire(item.end_date)}
                                    
                                </div>
                            </div>
                            <div className='inner-card-body'>
                                <Row className='inner-card-body-row'>
                                    <Col md={4} className='inner-card-body-col'>
                                        <p><strong>Company:</strong> {item.company_name}</p>
                                        <p><strong>Name:</strong> {item.name}</p>
                                    </Col>
                                    <Col md={4} className='inner-card-body-col'>
                                        <p><strong>Plan:</strong> {item.current_plan}</p>
                                        <p><strong>Total Credits:</strong> {item.credit_count}</p>
                                    </Col>
                                    <Col md={4} className='inner-card-body-col'>
                                        <p><strong>Credits Used:</strong> {item.aval_val}</p>
                                        <p><strong>Credits Left:</strong> {item.credit_count - item.aval_val}</p>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            })}
            </>
            }
        </div>
    </Card>
  )
}

export default SubscriptionDetails
